import React from "react";
import styles from "../../styles/components/auth/LoginShowcase.module.css";

const MOCK_POSTS = [
  {
    id: 1,
    name: "Sarah M.",
    handle: "@sarahm",
    avatar: "SM",
    color: "#3B7EF6",
    text: "Finally settled the iPhone vs Pixel debate. Simpary's battle view made it so clear!",
  },
  {
    id: 2,
    type: "comparison",
    title: "MacBook Air M3 vs Dell XPS 13",
    match: "92 Fit score for you",
  },
  {
    id: 3,
    name: "Alex K.",
    handle: "@alexk",
    avatar: "AK",
    color: "#3B7EF6",
    text: "Just posted my Sony WH-1000XM5 review. Honest take after 3 months of daily use.",
  },
  {
    id: 4,
    type: "deal",
    title: "Samsung Galaxy S25 — $200 off",
    source: "Best Buy · Verified deal",
  },
  {
    id: 5,
    name: "TechDeals",
    handle: "@techdeals",
    avatar: "TD",
    color: "#ec4899",
    text: "Head-to-head: iPad Pro vs Surface Pro for creative work. Community voted 68% iPad.",
  },
  {
    id: 6,
    name: "Jordan P.",
    handle: "@jordanp",
    avatar: "JP",
    color: "#0ea5e9",
    text: "Simpary's AI chat nailed my budget laptop pick. Under $800 and perfect for coding.",
  },
];

const leftPosts = MOCK_POSTS.filter((_, i) => i % 2 === 0);
const rightPosts = MOCK_POSTS.filter((_, i) => i % 2 === 1);

const renderCards = (posts, keyPrefix) =>
  [...posts, ...posts].map((post, index) => (
    <ShowcaseCard key={`${keyPrefix}-${post.id}-${index}`} post={post} />
  ));

const LoginShowcase = () => {
  return (
    <div className={styles.showcase} aria-hidden="true">
      <div className={styles.showcaseInner}>
        <div className={styles.columnTrack}>
          <div className={`${styles.columnScroll} ${styles.scrollUp}`}>
            {renderCards(leftPosts, "left")}
          </div>
        </div>
        <div className={styles.columnTrack}>
          <div className={`${styles.columnScroll} ${styles.scrollDown}`}>
            {renderCards(rightPosts, "right")}
          </div>
        </div>
      </div>
    </div>
  );
};

const ShowcaseCard = ({ post }) => {
  if (post.type === "comparison") {
    return (
      <div className={`${styles.card} ${styles.cardTall}`}>
        <div className={styles.comparisonBadge}>Product Battle</div>
        <p className={styles.comparisonTitle}>{post.title}</p>
        <div className={styles.comparisonBar}>
          <span className={styles.comparisonFill} />
        </div>
        <p className={styles.comparisonMatch}>{post.match}</p>
      </div>
    );
  }

  if (post.type === "deal") {
    return (
      <div className={`${styles.card} ${styles.cardTall}`}>
        <div className={styles.dealImage} />
        <p className={styles.dealTitle}>{post.title}</p>
        <p className={styles.dealSource}>{post.source}</p>
      </div>
    );
  }

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span
          className={styles.avatar}
          style={{ backgroundColor: post.color }}
        >
          {post.avatar}
        </span>
        <div>
          <p className={styles.cardName}>{post.name}</p>
          <p className={styles.cardHandle}>{post.handle}</p>
        </div>
      </div>
      <p className={styles.cardText}>{post.text}</p>
    </div>
  );
};

export default LoginShowcase;
